export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-array/src/identity.js
// module id = ../../../../d3-array/src/identity.js
// module chunks = 4